export default "__VITE_ASSET__31f6af33__"